import { render, staticRenderFns } from "./LittleGirls.vue?vue&type=template&id=0542195d&scoped=true"
import script from "./LittleGirls.vue?vue&type=script&lang=js"
export * from "./LittleGirls.vue?vue&type=script&lang=js"
import style0 from "./LittleGirls.vue?vue&type=style&index=0&id=0542195d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0542195d",
  null
  
)

export default component.exports